import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { EventsService } from 'src/app/services/events.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private api: ApiService,
    private eventsService: EventsService,
    private ev: EventsService
  ) { }

  notificationCount() {
    this.api.notificationCount().subscribe((res: any) => {
      // console.log(res);
      this.ev.onReloadMyProfile.emit();
      if (res && res.Code === 200 && 'Results' in res && res.Results && 'Badge' in res.Results && res.Results.Badge >= 0){
        this.eventsService.onNotificationCount.emit(res.Results.Badge.toString());
      }
    });
  }
}
